import { network } from '@utils'
import { handleReturn, MutationFunction } from './root'

export interface ISendNojaFormProps {
  slug: string
}

export interface INojaFormProps {
  business_id: string
  business_name: string
  contact_name: string
  contact_email: string
  contact_phone: string
}

export const sendNojaForm: MutationFunction<ISendNojaFormProps, INojaFormProps> = async (
  { slug },
  requestData
) => {
  const url = `/v1/business/${slug}/partner/noja/form/send/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'POST',
    data: requestData,
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}
